import { faCircleCheck, faStars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Card, Col, Row, Spinner } from 'react-bootstrap-5';
import { endTrial } from 'bundles/connect/helpers/prospect_api';
import { Button } from 'components/ui/button';
import { formatDateString } from 'bundles/connect/helpers/date_helpers';

type Props = {
  renewalDate: string;  
}

export default function EndTrial({ renewalDate }: Props) {
  const [activated, setActivated] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleActivate = () => {
    if (confirm('This will end your trial and start your subscription at the full price.')) {
      setLoading(true);
      endTrial().then(() => {
        setActivated(true);
        setLoading(false);
      });
    }
  };

  if (activated) {
    return (
      <Card bg="light">
        <Card.Body>
          <Row className="g-2">
            <Col xs="auto">
              <div className="d-flex border rounded p-2 bg-body-secondary align-items-center">
                <FontAwesomeIcon className="text-success" icon={faCircleCheck} />
              </div>
            </Col>
            <Col>
              <div className="fw-bold">Your subscription is now active.</div>
              <small>
                Thank you for activating your subscription. Please note that it may take a moment for our billing to
                synchronize. Your credits will replenish within a few minutes.
              </small>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card bg="light">
      <Card.Body>
        <Row className="gy-2">
          <Col className="d-none d-md-block" xs="auto">
            <div className="border rounded p-4 position-relative bg-body-secondary">
              <FontAwesomeIcon
                className="text-primary fa-lg position-absolute top-50 start-50 translate-middle"
                icon={faStars}
              />
            </div>
          </Col>
          <Col md>
            <div className="fw-bold">
              <FontAwesomeIcon className="text-primary d-md-none me-2" icon={faStars} />
              Activate Your Full Account
            </div>
            <small>
              Your trial will end on {formatDateString(renewalDate, 'long', false)}.
              You can activate your account at any time during this period to increase the amount of owner lookups and
              unlock exports.
            </small>
          </Col>
          <Col className="text-center" xs="auto">
            <Button
              disabled={loading}
              style={{ width: '175px' }}
              variant="outline"
              onClick={handleActivate}
            >
              {loading ? (
                <>
                  <Spinner animation="border" className="me-2" size="sm" />
                  Activating ...
                </>
              ) : (
                'Activate Account'
              )}
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
